import React, { memo, useMemo } from 'react';
import { Icon } from 'antd';
import cn from 'classnames';
import { useSearchParamsSelector } from '../../../../shared/packages/searchParamsManager';
import { searchParamKeys } from '../../../../shared/configs/searchParams';
import { useCompaniesQuery } from '../../../../api/companies';
import Btn, { btnTypes } from '../../../../../../components/btn';
import { ReactComponent as HouseIcon } from '../../../../../../resource/ModernHouseIcon.svg';
import { toInteger } from '../../../../shared/packages/searchParamsNormalizer';
import styles from './index.module.scss';

const Control = ({ visible, loading, disabled, ...props }) => {
  const currentCompanyId = useSearchParamsSelector((state) => {
    return toInteger(state[searchParamKeys.company]);
  });

  const { data } = useCompaniesQuery();

  const name = useMemo(
    () => data?.find((c) => c.id === currentCompanyId)?.name,
    [data, currentCompanyId]
  );

  return (
    <Btn
      {...props}
      disabled={disabled}
      type={btnTypes.primary}
      className={styles.control}
    >
      <Icon className={styles.icon} component={HouseIcon} />
      {name ?? 'Выберите компанию'}
      <Icon
        className={cn(styles.arrow, { [styles.visible]: visible })}
        type={loading ? 'loading' : 'down'}
      />
    </Btn>
  );
};

export default memo(Control);
